import React, { useRef, useState } from "react";
import useToken from "../../useToken";
import { baseUrl } from "../../config";

import './SubirComprobante.css';

const UploadIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 16V4m0 0 4 4m-4-4-4 4" />
        <path d="M4 17v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1" />
    </svg>
);

const SubirComprobante = ({ reserva }) => {
    const [file, setFile] = useState(reserva?.url || null);
    const [uploading, setUploading] = useState(false);
    const [dragging, setDragging] = useState(false);
    const { token } = useToken();
    const refInput = useRef(null);

    const uploadFile = (selectedFile) => {
        if (!selectedFile || !reserva?.idBooking) return;

        setUploading(true);
        const form = new FormData();
        form.append("file", selectedFile);
        form.append("idBooking", reserva.idBooking);

        fetch(baseUrl + "Booking/UploadFile", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: form,
        })
            .then((response) => response.json())
            .then((data) => {
                setFile(data?.fileUrl || null);
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
            })
            .finally(() => {
                setUploading(false);
            });
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        if (e.dataTransfer.files?.[0]) {
            uploadFile(e.dataTransfer.files[0]);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files?.[0]) {
            uploadFile(e.target.files[0]);
        }
    };

    const isPdf = typeof file === 'string' && file.toLowerCase().includes('.pdf');

    return (
        <div
            className={`xfer-drop${dragging ? ' is-dragging' : ''}${file ? ' has-file' : ''}${uploading ? ' is-uploading' : ''}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <input
                type="file"
                ref={refInput}
                accept="image/*,.pdf"
                onChange={handleFileChange}
                hidden
            />

            {!file && (
                <button
                    type="button"
                    className="xfer-drop__zone"
                    onClick={() => refInput.current?.click()}
                    disabled={uploading}
                >
                    <span className="xfer-drop__icon">
                        <UploadIcon />
                    </span>
                    <span className="xfer-drop__title">
                        {uploading ? 'Subiendo archivo…' : 'Arrastra tu comprobante aquí'}
                    </span>
                    <span className="xfer-drop__hint">o haz clic para seleccionar · JPG, PNG o PDF</span>
                </button>
            )}

            {file && (
                <div className="xfer-drop__preview">
                    {!isPdf ? (
                        <img src={file} alt="Vista previa del comprobante" />
                    ) : (
                        <div className="xfer-drop__file">
                            <span className="xfer-drop__file-badge">PDF</span>
                            <span className="xfer-drop__file-name">Comprobante adjunto</span>
                        </div>
                    )}
                    <button
                        type="button"
                        className="xfer-drop__change"
                        onClick={() => {
                            setFile(null);
                            if (refInput.current) refInput.current.value = '';
                        }}
                    >
                        Cambiar archivo
                    </button>
                </div>
            )}
        </div>
    );
};

export default SubirComprobante;
